<template>
  <div class="page-container">
    <el-card class="page-content" shadow="never">
      <div
        class="page-actions"
        style="display: flex; justify-content: space-between"
      >
        <div class="select">
          <div class="item">
            <div class="ipt">
              <el-select v-model="tenantId" placeholder="租户选择" clearable>
                <el-option
                  v-for="item in tenantList"
                  :key="item.id"
                  :label="item.tenantName"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </div>
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="handleSearch"
              >查询</el-button
            >
          </div>

          <div class="item">
            <el-button size="small" type="primary" @click="show('新增')"
              >新增</el-button
            >
          </div>
        </div>
      </div>
      <el-table :data="tabList" height="calc(100vh - 360px)" size="small">
        <el-table-column prop="ipAuth" label="id白名单" />
        <el-table-column prop="tenantId" label="商户ID" />
        <el-table-column label="商户名称" prop="tenantName" />
        <el-table-column label="角色" prop="">
          <template slot-scope="scope">
            <span>{{ (scope.row.roleNames || []).join("、") || "-" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="用户名" prop="userName" />
        <el-table-column prop="" label="是否绑定谷歌">
          <template slot-scope="scope">
            <span>{{ scope.row.googleBound ? "是" : "否" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="400">
          <template slot-scope="scope">
            <div class="btnsFlex">
              <el-button size="mini" @click="show('编辑', scope.row)"
                >编辑</el-button
              >
              <el-button size="mini" @click="setDisable(scope.row)">{{
                scope.row.disableLogin == true ? "启用" : "禁用"
              }}</el-button>
              <el-button type="danger" size="mini" @click="del(scope.row)"
                >删除</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="restPassWord(scope.row)"
                >重置密码</el-button
              >

              <el-button
                type="danger"
                size="mini"
                @click="deleteGoogle(scope.row)"
                >删除谷歌</el-button
              >
            </div>
          </template>
        </el-table-column>
      </el-table>
      <Pagination
        :size="pagination.size"
        :total="totalCount"
        :page="pagination.page"
        @pageChanged="paginationHandle"
      >
      </Pagination>

      <el-dialog
        :title="title"
        :visible="dialogVisible"
        width="400px"
        @close="close"
        :destroy-on-close="true"
      >
        <el-form
          ref="formData"
          :model="formData"
          size="medium"
          label-width="100px"
        >
          <el-form-item label="密码" prop="" v-if="title == '新增'">
            <el-input :min="0" v-model="formData.password"></el-input>
          </el-form-item>
          <el-form-item label="ip白名单" prop="">
            <el-input :min="0" v-model="formData.ipAuth"></el-input>
          </el-form-item>
          <el-form-item label="用户名" prop="">
            <el-input :min="0" v-model="formData.userName"></el-input>
          </el-form-item>
          <el-form-item label="租户" prop="" required>
            <el-select v-model="formData.tenantId" placeholder="租户" clearable @change="onFormTenantChange">
              <el-option
                v-for="item in tenantList"
                :key="item.id"
                :label="item.tenantName"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="角色(多选)" required>
            <el-select v-model="formData.roleIds" multiple collapse-tags placeholder="请选择角色" clearable>
              <el-option
                v-for="item in roleOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="close">取消</el-button>
          <el-button type="primary" @click="handleSave">确定</el-button>
        </div>
      </el-dialog>
    </el-card>
  </div>
</template>

<script>
import Pagination from "components/pagination";
import api from "./api";
import { tenantInfo } from "@/common/publicApi";
export default {
  components: {
    Pagination,
  },
  data() {
    return {
      tenantId: "",
      tenantList: [],
      tabList: [],
      totalCount: 0,
      pagination: {
        page: 1,
        size: 25,
      },
      dialogVisible: false,
      title: "新增",
      formData: {
        password: "",
        ipAuth: "",
        userName: "",
        tenantId: "",
        roleIds: [],
      },
      roleOptions: [],
    };
  },
  computed: {},
  mounted() {
    tenantInfo().then((res) => {
      if (res.code == 0) {
        this.tenantList = res.data;
      }
    });
    this.handleSearch();
  },
  methods: {
    handleSearch() {
      api
        .tenantUserList({
          tenantId: this.tenantId,
          ...this.pagination,
        })
        .then((res) => {
          if (res.code == 0) {
            const { totalCount, list } = res.data;
            this.tabList = list;
            this.totalCount = totalCount;
          }
        });
    },
    paginationHandle(pagination) {
      this.pagination = pagination;
      this.handleSearch();
    },
    show(str, row) {
      if (row) {
        this.formData = {
          id: row.id,
          password: "",
          ipAuth: row.ipAuth || "",
          userName: row.userName || "",
          tenantId: row.tenantId || "",
          roleIds: row.roleIds || [],
        };
      } else {
        this.formData = {
          password: "",
          ipAuth: "",
          userName: "",
          tenantId: this.tenantId || "",
          roleIds: [],
        };
      }
      this.title = str;
      this.dialogVisible = true;
      this.loadRoleOptions(this.formData.tenantId);
    },
    close() {
      this.dialogVisible = false;
      this.formData = {
        password: "",
        ipAuth: "",
        userName: "",
        tenantId: "",
        roleIds: [],
      };
      this.roleOptions = [];
    },
    onFormTenantChange(val) {
      this.formData.roleIds = [];
      this.loadRoleOptions(val);
    },
    loadRoleOptions(tenantId) {
      if (!tenantId && tenantId !== 0) {
        this.roleOptions = [];
        return;
      }
      api.roleOptions({ tenantId }).then((res) => {
        if (res.code == 0) {
          this.roleOptions = res.data || [];
        }
      });
    },
    handleSave() {
      if (this.title === "新增" && this.formData.password == "") {
        return this.$message.error("请输入密码");
      }
      if (this.formData.ipAuth == "") {
        return this.$message.error("请输入IP白名单");
      }
      if (this.formData.userName == "") {
        return this.$message.error("请输入用户名");
      }
      if (!this.formData.tenantId && this.formData.tenantId !== 0) {
        return this.$message.error("请选择租户");
      }
      if (!this.formData.roleIds || this.formData.roleIds.length === 0) {
        return this.$message.error("请至少选择一个角色");
      }
      let url = "";
      this.title === "新增" ? (url = "tenantUserAdd") : (url = "userEdit");
      let params = this.formData;
      if (this.title !== "新增") {
        params = {
          tenantId: this.formData.tenantId,
          userName: this.formData.userName,
          ipAuth: this.formData.ipAuth,
          id: this.formData.id,
          roleIds: (this.formData.roleIds || []).join(","),
        };
      } else {
        params = {
          ...this.formData,
          roleIds: (this.formData.roleIds || []).join(","),
        };
      }
      api[url](params).then((res) => {
        if (res.code == 0) {
          this.$message.success(this.title + "成功");
          this.close();
          this.handleSearch();
        }
      });
    },

    restPassWord(row) {
      this.$confirm("确定重置密码吗？", "提示", {
        type: "warning",
      }).then(() => {
        api.resetPassword({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            this.handleSearch();
          }
        });
      });
    },
    deleteGoogle(row) {
      this.$confirm("确定删除谷歌吗？", "提示", {
        type: "warning",
      }).then(() => {
        api.deleteGoogle({ id: row.id }).then((res) => {
          if (res.code == 0) {
            this.$message({
              type: "success",
              message: "操作成功！",
            });
            this.handleSearch();
          }
        });
      });
    },
    setDisable(row) {
      api
        .disableLogin({
          id: row.id,
          type: !row.disableLogin,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.handleSearch();
          }
        });
    },
    del(row) {
      api
        .remove({
          id: row.id,
        })
        .then((res) => {
          if (res.code == 0) {
            this.$message.success("操作成功");
            this.handleSearch();
          }
        });
    },
  },
};
</script>

<style lang="less" src="../../styles/button.less" scoped></style>
